import Immutable from 'immutable';
import { groupByLastFlag } from 'core/utils';

export const calculateStudentLessonProgressSummary = (
  profileId,
  classLessonProgress,
  studentLessonProgress
) => {
  const quizResults =
    studentLessonProgress && studentLessonProgress.get('quiz_results');
  return {
    visitedChunks:
      (studentLessonProgress && studentLessonProgress.get('visited_chunks')) ||
      Immutable.List(),
    questionAttempts:
      quizResults && quizResults.map((question) => question.get('attempts')),
    quizResultsTally:
      quizResults &&
      quizResults.reduce(
        (prev, question) => prev + question.get('marks_obtained'),
        0
      ),
    noteTaken:
      classLessonProgress &&
      classLessonProgress.getIn([
        'student_progress_notes_taken',
        `${profileId}`,
      ]),
    selfRating:
      studentLessonProgress && studentLessonProgress.get('self_rating'),
  };
};

export const getGuidingQuestionGroupChunks = (chunks) => {
  return groupByLastFlag(chunks).filter((chunkGroups) =>
    chunkGroups.some((cg) => cg.get('success_measure'))
  );
};

export const getGuidingQuestionLastChunkIds = (chunks) => {
  return getGuidingQuestionGroupChunks(chunks)
    .map((cg) => cg.filter((chunk, index) => index === cg.size - 1))
    .flatten(true)
    .map((chunk) => chunk.get('id'));
};

export const getGuidingQuestionFirstChunkIds = (chunks) => {
  return getGuidingQuestionGroupChunks(chunks)
    .map((cg) => cg.filter((chunk, index) => index === 0))
    .flatten(true)
    .map((chunk) => chunk.get('id'));
};

export const getNonGuidingQuestionChunkIds = (chunks) => {
  return groupByLastFlag(chunks)
    .filter(
      (chunkGroups) => !chunkGroups.some((cg) => cg.get('success_measure'))
    )
    .flatten(true)
    .map((chunk) => chunk.get('id'));
};
